import React, { useEffect, useState } from "react";
import { Button, Table } from "bootstrap-4-react/lib/components";
import { useNavigate } from "react-router";
import LoaderSpinner from "../common/Loader";
import eye_icon from "../../assets/eye_icon.svg";
import edit_icon from "../../assets/edit_icon.svg";
import { Tooltip as WmsTooltip } from "react-tooltip";
import BatchPagination from "../batch/BatchPagination";
import RentConfigurationFilter from "./RentConfigurationFilter";

/* istanbul ignore next */
const RentConfiguration = () => {
  const navigate = useNavigate();
  const [showLoader] = useState(false);

  const [totalPages, setTotalPages] = useState(1);
  const numOfPage = [30, 50, 100, 200, 500, 1000, 2000];
  const [rentList, setRentList] = useState([]);
  const [filterData, setFilterData] = useState({
    pageIndex: 1,
    pageSize: 30,
    sortColumn: '',
    sortOrder: 'DESCENDING',
    companyIdList: [],
    sellerIdList: [],
    rentFrequencyList: [],
    showFilter: false,
  });

  // Mock data based on wireframe - Replace with actual API call
  const mockRentData = [
    {
      id: 1,
      warehouse: "Dallas WH-01",
      companySeller: "Acme Corp / AcmeExports",
      rentFrequency: "Monthly",
      baselineRate: 820
    },
    {
      id: 2,
      warehouse: "Houston WH-02",
      companySeller: "GlobalTrade / GT-America",
      rentFrequency: "Weekly",
      baselineRate: 650
    },
    {
      id: 3,
      warehouse: "Chicago WH-05",
      companySeller: "Starline / SL-Imports",
      rentFrequency: "Monthly",
      baselineRate: 1050
    },
    {
      id: 4,
      warehouse: "New Jersey WH-07",
      companySeller: "BrightMart / BM-Supply",
      rentFrequency: "Weekly",
      baselineRate: 530
    },
    {
      id: 5,
      warehouse: "Los Angeles WH-09",
      companySeller: "Pacific Exports / PacEx",
      rentFrequency: "Monthly",
      baselineRate: 1220
    },
    {
      id: 6,
      warehouse: "Dallas WH-01",
      companySeller: "MegaShop / MS-Americas",
      rentFrequency: "Monthly",
      baselineRate: 570
    },
    {
      id: 7,
      warehouse: "Houston WH-02",
      companySeller: "PrimeGoods / PG-LLC",
      rentFrequency: "Monthly",
      baselineRate: 960
    },
    {
      id: 8,
      warehouse: "Chicago WH-05",
      companySeller: "NorthStar / NS-Exports",
      rentFrequency: "Weekly",
      baselineRate: 770
    },
    {
      id: 9,
      warehouse: "New Jersey WH-07",
      companySeller: "UnitedFoods / UF-America",
      rentFrequency: "Monthly",
      baselineRate: 1020
    }
  ];

  useEffect(() => {
    // Initialize with mock data - Replace with API call later
    setRentList(mockRentData);
    setTotalPages(Math.ceil(mockRentData.length / filterData.pageSize));
  }, [filterData.pageSize, filterData.pageIndex, filterData.sortColumn, filterData.sortOrder]);

  const handleSortingColumn = (event, sortColumn) => {
    event.preventDefault();
    let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
    setFilterData({
      ...filterData,
      sortColumn: sortColumn,
      sortOrder: newSortOrder,
      pageIndex: 1
    });
  };

  const handleSortingClass = (columnName, isArrow = false) => {
    if (isArrow) {
      return filterData.sortColumn === columnName && filterData.sortOrder === "ASCENDING"
        ? "fa fa-arrow-up"
        : "fa fa-arrow-down";
    }
    return filterData.sortColumn === columnName ? "active sortBtn" : "sortColumn sortBtn";
  };

  const setCurrentPagePagination = (value) => {
    setFilterData({ ...filterData, pageIndex: value });
  };

  const setTotalNumberOfPage = (value) => {
    setFilterData({ ...filterData, pageSize: value, pageIndex: 1 });
  };

  const handlePageView = () => {
    return (
      <tr>
        <td colSpan="6" align="center">
          <div className="notFound">No records to display</div>
        </td>
      </tr>
    );
  };

  const handleNavigateToRent = (item, type) => {
    const isViewMode = type === "view";
    navigate(`/rent-configuration/rent-${item.id}`, {
      state: {
        rentDetails: item,
        isViewMode: isViewMode
      },
    });
  };

  const handleExport = () => {
    // Export functionality - to be implemented
    console.log("Export rent configuration data");
  };

  const handleFilterToggle = () => {
    setFilterData({ ...filterData, showFilter: !filterData.showFilter });
  };

  const handleResetFilter = () => {
    setFilterData({
      ...filterData,
      companyIdList: [],
      sellerIdList: [],
      rentFrequencyList: [],
      showFilter: false,
      pageIndex: 1
    });
    // Reset to original mock data
    setRentList(mockRentData);
    setTotalPages(Math.ceil(mockRentData.length / filterData.pageSize));
  };

  const handleApplyFilter = () => {
    console.log("Apply filter with filterData:", filterData);
    // Filter logic - to be implemented with API
    // For now, filter mock data locally
    let filteredData = [...mockRentData];
    
    if (filterData.companyIdList && filterData.companyIdList.length > 0) {
      // Filter by company - mock implementation
      // In real implementation, this would be done via API
    }
    
    if (filterData.sellerIdList && filterData.sellerIdList.length > 0) {
      // Filter by seller - mock implementation
    }
    
    if (filterData.rentFrequencyList && filterData.rentFrequencyList.length > 0) {
      const selectedFrequencies = filterData.rentFrequencyList.map(item => item.value);
      filteredData = filteredData.filter(item => 
        selectedFrequencies.includes(item.rentFrequency)
      );
    }
    
    setRentList(filteredData);
    setTotalPages(Math.ceil(filteredData.length / filterData.pageSize));
    setFilterData({ ...filterData, showFilter: false });
  };

  return (
    <main>
      <div className="main__container">
        <div className="main__tile_heading cus-btn-include-sec">
          Rent Configuration
          <div className="top_right_button_container">
            <Button
              className="cus-seconday-bg-btn mr-2"
              onClick={handleExport}
            >
              Export
            </Button>
            <Button
              className="cus-seconday-bg-btn mr-2"
              onClick={handleFilterToggle}
            >
              Filter
            </Button>
            <Button
              className="cus-primary-transparent-btn"
              onClick={() => navigate("/setting")}
            >
              Back
            </Button>
          </div>
        </div>
        {showLoader && <LoaderSpinner />}
        {filterData.showFilter && (
          <RentConfigurationFilter
            showFilter={filterData.showFilter}
            handleReset={handleResetFilter}
            filterData={filterData}
            setfilterData={setFilterData}
            handleFilter={handleApplyFilter}
          />
        )}
        <div className="main_content_table_history incomingTbl tableFixHead">
          <Table className="table table-height">
            <thead>
              <tr>
                <th>
                  #
                </th>
                <th>
                  <button
                    className={handleSortingClass("warehouse")}
                    onClick={(e) => handleSortingColumn(e, "warehouse")}
                  >
                    Warehouse{" "}
                    <i
                      className={handleSortingClass("warehouse", true)}
                      aria-hidden="true"
                    ></i>
                  </button>
                </th>
                <th>
                  <button
                    className={handleSortingClass("companySeller")}
                    onClick={(e) => handleSortingColumn(e, "companySeller")}
                  >
                    Company / Seller{" "}
                    <i
                      className={handleSortingClass("companySeller", true)}
                      aria-hidden="true"
                    ></i>
                  </button>
                </th>
                <th>
                  <button
                    className={handleSortingClass("rentFrequency")}
                    onClick={(e) => handleSortingColumn(e, "rentFrequency")}
                  >
                    Rent Frequency{" "}
                    <i
                      className={handleSortingClass("rentFrequency", true)}
                      aria-hidden="true"
                    ></i>
                  </button>
                </th>
                <th>
                  <button
                    className={handleSortingClass("baselineRate")}
                    onClick={(e) => handleSortingColumn(e, "baselineRate")}
                  >
                    Baseline (Fixed) Rate{" "}
                    <i
                      className={handleSortingClass("baselineRate", true)}
                      aria-hidden="true"
                    ></i>
                  </button>
                </th>
                <th className="sticky">Action</th>
              </tr>
            </thead>
            <tbody>
              {rentList.length > 0 ? (
                <>
                  {rentList.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.warehouse}</td>
                      <td>{item.companySeller}</td>
                      <td>{item.rentFrequency}</td>
                      <td>{item.baselineRate}</td>
                      <td className="sticky">
                        <button
                          type="button"
                          className="editIcon mr-15 sortBtn"
                          onClick={() => handleNavigateToRent(item, "view")}
                          id={`${item.id}-view`}
                          style={{ cursor: "pointer" }}
                          data-testid="viewIcon"
                        >
                          <img
                            src={eye_icon}
                            alt="View"
                            className="editIconImage"
                          />
                        </button>
                        <button
                          type="button"
                          className="editIcon mr-15 sortBtn"
                          onClick={() => handleNavigateToRent(item, "edit")}
                          id={`${item.id}-edit`}
                          style={{ cursor: "pointer" }}
                          data-testid="editIcon"
                        >
                          <img
                            src={edit_icon}
                            alt="Edit"
                            className="editIconImage"
                          />
                        </button>
                        <WmsTooltip
                          anchorId={`${item.id}-view`}
                          content="View"
                          place="right"
                          className="tooltipWidth"
                        />
                        <WmsTooltip
                          anchorId={`${item.id}-edit`}
                          content="Edit"
                          place="right"
                          className="tooltipWidth"
                        />
                      </td>
                    </tr>
                  ))}
                </>
              ) : (
                handlePageView()
              )}
            </tbody>
          </Table>
        </div>
        {rentList && (
          <BatchPagination
            gridData={rentList}
            totalVisualRecords={rentList.length}
            numberOfPage={filterData?.pageSize}
            numOfPage={numOfPage}
            currentPage={filterData?.pageIndex}
            totalPages={totalPages || 0}
            totalRecords={rentList.length}
            setCurrentPage={setCurrentPagePagination}
            setNumberOfPage={setTotalNumberOfPage}
          />
        )}
      </div>
    </main>
  );
};

export default RentConfiguration;
